import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminCaseSimulator = lazy(() => import("@/pages/admin/AdminCaseSimulator"));

export const Route = createFileRoute("/admin/arenden/testlage")({
  head: () => ({ meta: [{ title: "Testläge för mejl – Adminpanel" }] }),
  component: AdminCaseSimulator,
});
